'use client'

import { useEffect, useRef } from 'react'
import { capturePostHogEvent } from '@/lib/posthog-client'

type PageViewProps = Record<string, string | boolean | undefined | null>

/**
 * Fires a page-view style event once per mount (one fire per page view).
 * Use for taxonomy events that mean "user viewed this page" (e.g. pricing_viewed).
 */
export function usePostHogPageView(eventName: string, props?: PageViewProps) {
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) return
    fired.current = true
    capturePostHogEvent(eventName, props)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fire once per page view
  }, [])
}
